export enum UserGeneratedWidgetType {
	LINE = 'line',
	BAR = 'bar',
	DONUT = 'donut',
	LIST = 'list',
	BLOCK = 'block',
	HEATMAP = 'heatmap',
	TREEMAP = 'treemap',
}
